import { gql } from '@apollo/client';

export const GET_ASSET_QUERY = gql`
  query GetAsset($id: Int!) {
    getAsset(id: $id) {
      statusCode
      message
      asset {
        id
        assetId
        name
        type
        gold_weight
        copper_weight
        copper_price
        certificateUrl
        imageUrl
        pricePerToken
        availableTokens
        stageMultiplier
        tokenizedPercentage
        totalTokens
        totalMintedTokens
        minimumInvestmentAmount
        nav
        navLastUpdated
        nftTokenId
        erc3643Address
        tokenRef
        explorerUrl
        chain
        tokenStandard
        requireAccreditedInvestor
        isActive
        createdAt
        updatedAt
        erc3643 {
          name
          symbol
          decimals
          totalSupply
          owner
          tokenAddress
          identityRegistry
          compliance {
            engine
            requestedEngine
            inSync
            aceTargetId
            aceTargetStatus
            policyEngineAddress
            protectedMethods
          }
          createdAt
        }
        nfts {
          id
          assetId
          tokenId
          owner
          metadata
          createdAt
        }
      }
    }
  }
`;
